import { Products } from '@tameeni/shared-logic';
import { SubNavItem } from '@tameeni/ui';
import { useTranslation } from 'react-i18next';

const HeaderHealthSubItems = ({
  HOME_LINKS,
  className,
  PRODUCTS_FLAT,
}: {
  HOME_LINKS: Record<Products, string>;
  className: string;
  PRODUCTS_FLAT: Products[];
}) => {
  const { t } = useTranslation(['home']);
  return (
    <div className={className}>
      <div>
        <h3 className='mb-4 text-sm font-medium text-slate-500'>
          {t('home:megaMenu.forBusiness')}
        </h3>
        <div className='space-y-2'>
          {PRODUCTS_FLAT.includes(Products.HEALTH_SME) && (
            <SubNavItem
              description={t('products:description.HEALTH_SME')}
              icon='HealthSme'
              label={t(
                `products:${Object.keys(Products).find((key) => {
                  return Products[key as keyof typeof Products] === Products.HEALTH_SME;
                })}`,
              )}
              link={HOME_LINKS[Products.HEALTH_SME]}
              arrowClassName='rtl:scale-x-[-1]'
            />
          )}
        </div>
      </div>
      <div>
        <h3 className='mb-4 text-sm font-medium text-slate-500'>
          {t('home:megaMenu.forIndividual')}
        </h3>
        <div className='space-y-2'>
          {PRODUCTS_FLAT.includes(Products.PREMIUM_RESIDENCY) && (
            <SubNavItem
              description={t('products:description.PREMIUM_RESIDENCY')}
              icon='HealthColored'
              label={t(
                `products:${Object.keys(Products).find((key) => {
                  return Products[key as keyof typeof Products] === Products.PREMIUM_RESIDENCY;
                })}`,
              )}
              link={HOME_LINKS[Products.PREMIUM_RESIDENCY]}
              arrowClassName='rtl:scale-x-[-1]'
            />
          )}
          {PRODUCTS_FLAT.includes(Products.HEALTH_INDIVIDUAL) && (
            <SubNavItem
              description={t('products:description.HEALTH_INDIVIDUAL')}
              icon='DomesticHelper'
              label={t(
                `products:${Object.keys(Products).find((key) => {
                  return Products[key as keyof typeof Products] === Products.HEALTH_INDIVIDUAL;
                })}`,
              )}
              link={HOME_LINKS[Products.HEALTH_INDIVIDUAL]}
              arrowClassName='rtl:scale-x-[-1]'
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default HeaderHealthSubItems;
